import styled, { css } from 'styled-components';
import { readableColor } from 'polished';
import * as colors from 'Styles/colors';
import { fontTitle } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';

export const Badge = styled.span`
  position: absolute;
  z-index: 1;
  ${({ $badgeColor = 'green' }) =>
    `background-color: ${colors[$badgeColor]};
    color: ${readableColor(colors[$badgeColor], colors.white, colors.black)}`};
  ${fontTitle(12)}
  text-transform: capitalize;
  padding: 3px 6px;
  margin: 8px;
  border-radius: 2px;

  ${({ $styleQueryMode }) => css`
    ${breakpoint('medium', { mode: $styleQueryMode })} {
      ${fontTitle(14)}
      padding: 3px 8px;
      margin: 12px;
    }
  `}
`;

export default {};
